import { AppProvider, useApp, useHashRoute, parseRoute } from "./store.jsx";
import Header from "./components/Header.jsx";
import HomePage from "./pages/HomePage.jsx";
import DeptPage from "./pages/DeptPage.jsx";
import TaskPage from "./pages/TaskPage.jsx";
import SettingsPage from "./pages/SettingsPage.jsx";
import LoginScreen from "./components/LoginScreen.jsx";

function Router() {
  const { auth } = useApp();
  const hash = useHashRoute();
  const route = parseRoute(hash);

  if (auth.loading) {
    return <div className="container">Loading…</div>;
  }
  if (auth.required && !auth.authenticated) {
    return <LoginScreen/>;
  }

  return (
    <>
      <Header hash={hash}/>
      {route.name === "home"     && <HomePage/>}
      {route.name === "dept"     && <DeptPage dept={route.dept}/>}
      {route.name === "task"     && <TaskPage id={route.id}/>}
      {route.name === "settings" && <SettingsPage/>}
      <ToastBar/>
      <ErrorBanner/>
    </>
  );
}

function ToastBar() {
  const { toast } = useApp();
  if (!toast) return null;
  return <div className="toast">{toast}</div>;
}

function ErrorBanner() {
  const { error, refresh } = useApp();
  if (!error) return null;
  return (
    <div className="toast" style={{borderColor:"#7f1d1d", color:"#f87171"}}>
      ⚠️ {String(error.message || error)} &nbsp;
      <button className="btn" onClick={refresh}>Retry</button>
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <Router/>
    </AppProvider>
  );
}
